<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="page_title"></page-header-title>

        <v-spacer></v-spacer>

        <action-button type="back" @click="$router.go(-1)" />
        <action-button type="save" @click="save" />

        <action-button
          v-if="isSetup"
          type="default"
          @click="setup(tennant.id)"
          :text="$t('tennants.setup')"
          color="info"
          icon="fas fa-tools"
        />
        <action-button
          v-if="isMigrate"
          type="default"
          @click="migrate(tennant.id)"
          :text="$t('tennants.run_migration_short')"
          color="info"
          icon="fas fa-database"
        />

        <action-button type="delete" @click="del(tennant.id)" v-if="tennant.id && $can('tennant-delete')" />

        <v-btn icon @click="toggleCollapse" class="darken-2">
          <v-icon>{{ collapseExpandIcon }}</v-icon>
        </v-btn>
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-autocomplete
                  name="tennant.organisation_id"
                  v-model="tennant.organisation_id"
                  class="required-field"
                  v-validate="'required'"
                  :items="organisations"
                  item-text="name"
                  item-value="id"
                  :label="$t('organisations.title')"
                  autocomplete="new-password"
                  :error-messages="errors.collect('tennant.organisation_id')"
                  @change="organisationChange"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex lg2 md4 sm6 xs12>
                <v-select
                  name="tennant.type"
                  v-model="tennant.type"
                  class="required-field"
                  v-validate="'required'"
                  item-text="text"
                  item-value="key"
                  :items="this.$dd_tenant_types()"
                  :label="$t('tennants.type')"
                  :error-messages="errors.collect('tennant.type')"
                ></v-select>
              </v-flex>
              <v-flex lg2 md4 sm6 xs12>
                <v-text-field
                  name="tennant.subdomain"
                  class="required-field"
                  v-validate="'required'"
                  v-model="tennant.subdomain"
                  :label="$t('tennants.subdomain')"
                  :error-messages="errors.collect('tennant.subdomain')"
                  @blur="subdomainChange"
                  @keypress="$keyDown_LetterDigitOnly($event)"
                  :disabled="!tennant.type"
                  autocomplete="new-password"
                  :hint="$t('tennants.select_tenant_type_first')"
                  :persistent-hint="tennant.type ? false : true"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="tennant.tenant_company"
                  v-model="tennant.tenant_company"
                  :label="$t('tennants.tenant_company')"
                  :error-messages="errors.collect('tennant.tenant_company')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg2 md4 sm6 xs12>
                <v-text-field
                  name="tennant.tenant_vat_number"
                  v-model="tennant.tenant_vat_number"
                  :label="$t('tennants.tenant_vat_number')"
                  :error-messages="errors.collect('tennant.tenant_vat_number')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex xs12> </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-autocomplete
                  name="tennant.person_id"
                  v-model="tennant.person_id"
                  :items="persons"
                  item-text="full_name"
                  item-value="id"
                  :label="$t('persons.title')"
                  autocomplete="new-password"
                  :error-messages="errors.collect('persons.title')"
                  @change="personChange(tennant.person_id)"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="tennant.first_name"
                  class="required-field"
                  v-validate="'required|max:255'"
                  v-model="tennant.first_name"
                  :label="$t('tennants.first_name')"
                  :error-messages="errors.collect('tennant.first_name')"
                  :disabled="Boolean(tennant.person_id)"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="tennant.last_name"
                  class="required-field"
                  v-validate="'required|max:255'"
                  v-model="tennant.last_name"
                  :label="$t('tennants.last_name')"
                  :error-messages="errors.collect('tennant.last_name')"
                  :disabled="Boolean(tennant.person_id)"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <vue-tel-input-vuetify
                  v-validate="'required'"
                  :label="$t('tennants.mobile')"
                  v-model="tennant.mobile"
                  @input="
                    (formattedNumber, { number, valid, country }) => {
                      tennant.mobile = number.significant || formattedNumber
                      tennant.mobile_code = country.dialCode || null
                    }
                  "
                  placeholder=""
                  name="tennant.mobile"
                  :error-messages="errors.collect('tennant.mobile')"
                  defaultCountry="NO"
                ></vue-tel-input-vuetify>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="tennant.email"
                  class="required-field"
                  v-validate="'required|max:255|email'"
                  v-model="tennant.email"
                  :label="$t('tennants.email')"
                  :error-messages="errors.collect('tennant.email')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-dialog ref="dialog" v-model="active_from_menu" persistent width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      name="tennant.active_from"
                      v-model="computedActiveFromDate"
                      :label="$t('tennants.active_from')"
                      class="required-field"
                      v-validate="'required'"
                      :error-messages="errors.collect('tennant.active_from')"
                      append-icon="event"
                      @click:append="active_from_menu = true"
                      :hint="'Format: ' + DATE_FORMAT"
                      autocomplete="new-password"
                    ></v-text-field>
                  </template>
                  <v-date-picker color="primary" v-model="tennant.active_from" :locale="this.$locale_bcp47()" first-day-of-week="1">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="active_from_menu = false" class="darken-2">{{ $t("global.ok") }}</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-dialog ref="dialog" v-model="inactive_from_menu" persistent width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      name="tennant.inactive_from"
                      v-model="computedInactiveFromDate"
                      :label="$t('tennants.inactive_from')"
                      :error-messages="errors.collect('tennant.inactive_from')"
                      append-icon="event"
                      @click:append="inactive_from_menu = true"
                      :hint="'Format: ' + DATE_FORMAT"
                      autocomplete="new-password"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    color="primary"
                    v-model="tennant.inactive_from"
                    first-day-of-week="1"
                    :locale="this.$locale_bcp47()"
                    :min="tennant.active_from"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="inactive_from_menu = false" class="darken-2">{{ $t("global.ok") }}</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-select
                  name="tennant.checklist_status"
                  v-model="tennant.checklist_status"
                  item-text="text"
                  item-value="key"
                  :items="this.$dd_tennant_sms_service()"
                  :label="$t('tennants.checklist_status')"
                  :error-messages="errors.collect('tennant.checklist_status')"
                ></v-select>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-select
                  name="tennant.sms_service"
                  v-model="tennant.sms_service"
                  class="required-field"
                  v-validate="'required'"
                  item-text="text"
                  item-value="key"
                  :items="this.$dd_tennant_sms_service()"
                  :label="$t('tennants.sms_service')"
                  :error-messages="errors.collect('tennant.sms_service')"
                  clearable
                ></v-select>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-select
                  name="tennant.status"
                  v-model="tennant.status"
                  class="required-field"
                  v-validate="'required'"
                  item-text="text"
                  item-value="key"
                  :items="this.$dd_tennant_status()"
                  :label="$t('tennants.status')"
                  :error-messages="errors.collect('tennant.status')"
                  :disabled="!tennant.is_setup"
                  clearable
                ></v-select>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="tennant.payed_for_users"
                  class="required-field"
                  v-validate="'required|numeric'"
                  v-model="tennant.payed_for_users"
                  :label="$t('tennants.payed_for_users')"
                  :error-messages="errors.collect('tennant.payed_for_users')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="tennant.course_id_increment_start"
                  class="required-field"
                  v-validate="'required|numeric|max:6'"
                  v-model="tennant.course_id_increment_start"
                  :label="$t('tennants.course_id_increment_start')"
                  :error-messages="errors.collect('tennant.course_id_increment_start')"
                  autocomplete="new-password"
                  :disabled="Boolean(tennant.id && tennant.is_setup)"
                >
                  <help-text slot="append" :tooltip="$t('tennants.course_id_increment_start_helptext')" />
                </v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="tennant.swagger_token"
                  v-model="tennant.swagger_token"
                  :label="$t('tennants.swagger_token')"
                  :error-messages="errors.collect('tennant.swagger_token')"
                  autocomplete="new-password"
                  append-outer-icon="refresh"
                  @click:append-outer="generateNewSwaggerToken"
                  readonly
                >
                </v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="tennant.notif_email_from"
                  v-validate="'email'"
                  v-model="tennant.notif_email_from"
                  :label="$t('tennants.notif_email_from')"
                  :error-messages="errors.collect('tennant.notif_email_from')"
                  autocomplete="new-password"
                  :class="
                    'notif_email_from ' + predata.notif_email_from ? (predata.notif_email_verified ? 'verified' : 'not-verified') : ''
                  "
                  :hint="
                    predata.notif_email_from == tennant.notif_email_from
                      ? predata.notif_email_from
                        ? predata.notif_email_verified
                          ? $t('tennants.notif_email_verified')
                          : $t('tennants.notif_email_not_verified')
                        : ''
                      : ''
                  "
                  persistent-hint
                >
                  <template
                    slot="append"
                    v-if="predata.notif_email_from && !predata.notif_email_verified && predata.notif_email_from == tennant.notif_email_from"
                  >
                    <action-button
                      type="reset"
                      :text="$t('tennants.resend_verify')"
                      small
                      :icon_only="true"
                      class="resend-verify mb-1"
                      @click="resendVerifyNotifEmail"
                    />
                  </template>
                </v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <vue-tel-input-vuetify
                  :label="$t('tennants.notif_sms_from')"
                  v-model="tennant.notif_sms_from"
                  @input="
                    (formattedNumber, { number, valid, country }) => {
                      tennant.notif_sms_from = number.significant || formattedNumber
                      tennant.notif_sms_from_code = country.dialCode || null
                    }
                  "
                  placeholder=""
                  name="tennant.notif_sms_from"
                  :error-messages="errors.collect('tennant.notif_sms_from')"
                  defaultCountry="NO"
                  :disabled="!tennant.sms_service"
                ></vue-tel-input-vuetify>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-expansion-panels
          v-model="clpsInvDetExp"
          class="cstm-filter mt-4 elevation-0"
          v-if="tennant.id && tennant.status == 1 && tennant.is_setup == 1"
        >
          <v-expansion-panel>
            <v-expansion-panel-header hide-actions>
              <span>
                <v-icon dark>{{ clpsInvDetIcon }}</v-icon>
                {{ $t("organisations.invoice_title") }}
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-layout row wrap>
                <v-flex lg3 md4 sm6 xs12>
                  <v-text-field
                    name="organisation.vat"
                    v-model="tennant_organisation.vat"
                    v-validate="'max:9'"
                    :label="$t('organisations.vat')"
                    :error-messages="errors.collect('organisation.vat')"
                    :hint="$t('global.helptext_vat')"
                    persistent-hint
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
                <v-flex lg3 md4 sm6 xs12>
                  <v-text-field
                    name="organisation.email"
                    v-model="tennant_organisation.email"
                    v-validate="'email|max:255'"
                    :label="$t('organisations.email')"
                    :error-messages="errors.collect('organisation.email')"
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
                <v-flex lg3 md4 sm6 xs12>
                  <v-text-field
                    name="organisation.phone"
                    v-model="tennant_organisation.phone"
                    v-validate="'max:20'"
                    :label="$t('organisations.phone')"
                    :error-messages="errors.collect('organisation.phone')"
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
                <v-flex lg3 md4 sm6 xs12>
                  <v-text-field
                    v-model="tennant_organisation.po_number"
                    v-validate="'max:50'"
                    :label="$t('organisations.po_number')"
                    :error-messages="errors.collect('organisation.po_number')"
                    data-vv-name="organisation.po_number"
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
                <v-flex lg3 md4 sm6 xs12>
                  <v-text-field
                    v-model="tennant_organisation.invoice_ref"
                    v-validate="'max:50'"
                    :label="$t('organisations.invoice_ref')"
                    :error-messages="errors.collect('organisation.invoice_ref')"
                    data-vv-name="organisation.invoice_ref"
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
                <v-flex lg3 md4 sm6 xs12>
                  <v-text-field
                    v-model="tennant_organisation.email_invoice"
                    v-validate="'max:255'"
                    :label="$t('organisations.email_invoice')"
                    :error-messages="errors.collect('organisation.email_invoice')"
                    data-vv-name="organisation.email_invoice"
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-expansion-panels
          v-model="clpsVisAddExp"
          class="cstm-filter mt-4 elevation-0"
          v-if="tennant.id && tennant.status == 1 && tennant.is_setup == 1"
        >
          <v-expansion-panel>
            <v-expansion-panel-header hide-actions>
              <span>
                <v-icon dark>{{ clpsVisAddIcon }}</v-icon>
                {{ $t("organisations.visiting_address_title") }}
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-layout row wrap>
                <v-flex md3 sm6 xs12>
                  <v-text-field
                    name="visiting_address.street"
                    v-model="tennant_visiting_address.street"
                    v-validate="'max:50'"
                    :label="$t('organisations.visiting_street')"
                    :error-messages="errors.collect('visiting_address.street')"
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
                <v-flex md1 sm2 xs12>
                  <v-text-field
                    name="visiting_address.zip"
                    v-model="tennant_visiting_address.zip"
                    v-validate="'max:10'"
                    :label="$t('organisations.visiting_zip')"
                    :error-messages="errors.collect('visiting_address.zip')"
                    @blur="visitingZipCodeChange"
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
                <v-flex md2 sm4 xs12>
                  <v-text-field
                    name="visiting_address.city"
                    v-model="tennant_visiting_address.city"
                    v-validate="'max:50'"
                    :label="$t('organisations.visiting_city')"
                    :error-messages="errors.collect('visiting_address.city')"
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
                <v-flex md3 sm6 xs12>
                  <v-text-field
                    name="visiting_addressg.state"
                    v-model="tennant_visiting_address.state"
                    v-validate="'max:50'"
                    :label="$t('organisations.visiting_state')"
                    :error-messages="errors.collect('visiting_address.state')"
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>

                <v-flex md3 sm6 xs12>
                  <v-autocomplete
                    name="visiting_address.country"
                    v-model="tennant_visiting_address.country"
                    :items="this.$dd_countries()"
                    item-text="text"
                    item-value="key"
                    :label="$t('organisations.visiting_country')"
                    autocomplete="new-password"
                    :error-messages="errors.collect('visiting_address.country')"
                    clearable
                  ></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-expansion-panels
          v-model="clpsInvAddExp"
          class="cstm-filter mt-4 elevation-0"
          v-if="tennant.id && tennant.status == 1 && tennant.is_setup == 1"
        >
          <v-expansion-panel>
            <v-expansion-panel-header hide-actions>
              <span>
                <v-icon dark>{{ clpsInvAddIcon }}</v-icon>
                {{ $t("organisations.invoice_address_title") }}
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-checkbox v-model="sameAsVisitingAddress" :label="$t('organisations.same_as_visiting')"></v-checkbox>
                </v-flex>
                <v-flex md3 sm6 xs12>
                  <v-text-field
                    name="invoice_address.street"
                    v-model="tennant_invoice_address.street"
                    v-validate="'max:50'"
                    :label="$t('organisations.invoice_street')"
                    :error-messages="errors.collect('invoice_address.street')"
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
                <v-flex md1 sm2 xs12>
                  <v-text-field
                    name="invoice_address.zip"
                    v-model="tennant_invoice_address.zip"
                    v-validate="'max:10'"
                    :label="$t('organisations.invoice_zip')"
                    :error-messages="errors.collect('invoice_address.zip')"
                    @blur="invoiceZipCodeChange"
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
                <v-flex md2 sm4 xs12>
                  <v-text-field
                    name="invoice_address.city"
                    v-model="tennant_invoice_address.city"
                    v-validate="'max:50'"
                    :label="$t('organisations.invoice_city')"
                    :error-messages="errors.collect('invoice_address.city')"
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
                <v-flex md3 sm6 xs12>
                  <v-text-field
                    name="invoice_address.state"
                    v-model="tennant_invoice_address.state"
                    v-validate="'max:50'"
                    :label="$t('organisations.invoice_state')"
                    :error-messages="errors.collect('invoice_address.state')"
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>

                <v-flex md3 sm6 xs12>
                  <v-autocomplete
                    name="invoice_address.country"
                    v-model="tennant_invoice_address.country"
                    :items="this.$dd_countries()"
                    item-text="text"
                    item-value="key"
                    :label="$t('organisations.invoice_country')"
                    autocomplete="new-password"
                    :error-messages="errors.collect('invoice_address.country')"
                    clearable
                  ></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-expansion-panels v-model="clpsDBExp" class="cstm-filter mt-4 elevation-0">
          <v-expansion-panel>
            <v-expansion-panel-header hide-actions>
              <span>
                <v-icon dark>{{ clpsDBIcon }}</v-icon>
                {{ $t("tennants.database_title") }}
                <help-text slot="append" :tooltip="$t('tennants.help_tenant_database')" />
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-layout row wrap>
                <v-flex lg3 md4 sm6 xs12>
                  <v-select
                    name="tennant.connection_name"
                    v-model="tennant.connection_name"
                    class="required-field"
                    v-validate="'required'"
                    item-text="text"
                    item-value="key"
                    :items="this.$dd_tenant_connection_names()"
                    :label="$t('tennants.connection_name')"
                    :error-messages="errors.collect('tennant.connection_name')"
                  ></v-select>
                </v-flex>
                <v-flex lg3 md4 sm6 xs12>
                  <v-text-field
                    name="tennant.dbname"
                    class="required-field"
                    v-validate="'required'"
                    v-model="tennant.dbname"
                    :label="$t('tennants.dbname')"
                    :error-messages="errors.collect('tennant.dbname')"
                    @keypress="$keyDown_LetterOnly($event)"
                    @blur="checkDatabaseExist()"
                    autocomplete="new-password"
                    :readonly="Boolean(tennant.id)"
                  >
                    <template v-slot:append>
                      <v-fade-transition leave-absolute>
                        <v-icon :color="db_icon_color">{{ db_icon }}</v-icon>
                      </v-fade-transition>
                    </template>
                  </v-text-field>
                </v-flex>
                <v-flex lg3 md4 sm6 xs12>
                  <v-text-field
                    name="tennant.master_username"
                    class="required-field"
                    v-validate="'required'"
                    v-model="tennant.master_username"
                    :label="$t('tennants.master_username')"
                    :error-messages="errors.collect('tennant.master_username')"
                    @keypress="$keyDown_LetterOnly($event)"
                    autocomplete="new-password"
                    :readonly="Boolean(tennant.id)"
                  ></v-text-field>
                </v-flex>
                <v-flex lg3 md4 sm6 xs12>
                  <v-text-field
                    name="tennant.master_password"
                    class="required-field"
                    v-validate="'required'"
                    v-model="tennant.master_password"
                    :label="$t('tennants.master_password')"
                    :error-messages="errors.collect('tennant.master_password')"
                    :append-icon="hidePassword ? 'visibility_off' : 'visibility'"
                    @click:append="() => (hidePassword = !hidePassword)"
                    :type="hidePassword ? 'password' : 'text'"
                    autocomplete="new-password"
                    :readonly="Boolean(tennant.id)"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-expansion-panels v-model="clpsSMSExp" class="cstm-filter mt-4 elevation-0" v-if="tennant.id">
          <v-expansion-panel>
            <v-expansion-panel-header hide-actions>
              <span>
                <v-icon dark>{{ clpsSMSIcon }}</v-icon>
                {{ $t("reports.report_sms_usage") }}
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>{{ $t("reports.year") }}</th>
                      <th v-for="month in moment.monthsShort()" :key="month">
                        {{ month }}
                      </th>
                    </tr>
                  </thead>
                  <tbody v-for="item in sms_report" :key="item.id">
                    <tr>
                      <td>{{ item.year }}</td>
                      <td v-for="month in item.months" :key="month.month">
                        {{ month.count || 0 }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-expansion-panels v-model="clpsCTGExp" class="cstm-filter mt-4 elevation-0">
          <v-expansion-panel>
            <v-expansion-panel-header hide-actions>
              <span>
                <v-icon dark>{{ clpsCTGIcon }}</v-icon>
                {{ $t("organisations.course_types_and_group") }}
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-layout row wrap>
                <v-flex xl4 lg4 md6 sm6 xs12 v-for="(items, index) in ctg_ct_list_columns" :key="index">
                  <v-card tile height="100%">
                    <!-- Course Type Group -->
                    <div v-for="(ctg, index) in items" :key="index">
                      <v-list-item class="secondary" :v-if="ctg.type == 'coursetypegroup'">
                        <v-list-item-action>
                          <v-checkbox
                            v-model="allowed_coursetypegroups"
                            :value="ctg.id"
                            color="primary"
                            @change="courseTypeGroupChange(ctg.id)"
                          ></v-checkbox>
                        </v-list-item-action>

                        <v-list-item-content>
                          <v-list-item-title>
                            <span>{{ ctg.fullname }}</span>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>

                      <!-- Course Types -->
                      <v-list-item v-for="(ct, index) in ctg.coursetypes" :key="index" :v-if="ct.type == 'coursetype'">
                        <v-list-item-action>
                          <v-checkbox
                            v-model="allowed_coursetypes"
                            :value="ct.id"
                            color="primary"
                            @change="courseTypeChange()"
                          ></v-checkbox>
                        </v-list-item-action>

                        <v-list-item-content>
                          <v-list-item-title>
                            <span>{{ ct.fullname }}</span>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </div>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-expansion-panels
          v-model="clpsIntExp"
          class="cstm-filter mt-4 elevation-0"
          v-if="tennant.id && predata.type == 1 && $can('tenantintegration-access')"
        >
          <v-expansion-panel>
            <v-expansion-panel-header hide-actions>
              <span>
                <v-icon dark>{{ clpsIntIcon }}</v-icon>
                {{ $t("integrations.title") }}
              </span>
              <v-spacer></v-spacer>
              <div class="text-right">
                <v-btn color="success" small class="cstm-v-btn darken-2" @click.stop="showForm(null, 'tenant-integration', tennant.id)">
                  <v-icon small>fas fa-plus</v-icon>
                </v-btn>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-layout row wrap>
                <v-flex md12>
                  <v-data-table
                    :headers="headers_integrations"
                    :items="integrations"
                    :items-per-page="integrations.length"
                    :options.sync="i_pagination"
                    :footer-props="{
                      showFirstLastPage: true,
                      'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
                      'items-per-page-all-text': $t('global.items_per_page_all_text'),
                      'items-per-page-text': $t('global.items_per_page_text'),
                      'page-text': $t('global.page_text')
                    }"
                    :server-items-length="i_total"
                    :loading="i_show_loading"
                    :loading-text="$t('global.loading_text')"
                    :no-data-text="$t('global.no_data_text')"
                    :no-results-text="$t('global.no_results_text')"
                    :must-sort="true"
                  >
                    <template v-slot:item.status="{ item }">
                      {{ $dd_integration_status(item.status) }}
                    </template>

                    <template v-slot:item.actions="{ item }">
                      <action-button type="edit" @click="showForm(item.id, 'tenant-integration', tennant.id)" :icon_only="true" small />
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-expansion-panels
          v-model="clpsModExp"
          class="cstm-filter mt-4 elevation-0"
          v-if="tennant.id && predata.type == 1 && $can('tenantmodule-access')"
        >
          <v-expansion-panel>
            <v-expansion-panel-header hide-actions>
              <span>
                <v-icon dark>{{ clpsModIcon }}</v-icon>
                {{ $t("modules.extra_title") }}
              </span>
              <v-spacer></v-spacer>
              <div class="text-right">
                <v-btn color="success" small class="cstm-v-btn darken-2" @click.stop="showForm(null, 'tenant-module', tennant.id)">
                  <v-icon small>fas fa-plus</v-icon>
                </v-btn>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-layout row wrap>
                <v-flex md12>
                  <v-data-table
                    :headers="headers_modules"
                    :items="modules"
                    :items-per-page="modules.length"
                    :options.sync="m_pagination"
                    :footer-props="{
                      showFirstLastPage: true,
                      'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
                      'items-per-page-all-text': $t('global.items_per_page_all_text'),
                      'items-per-page-text': $t('global.items_per_page_text'),
                      'page-text': $t('global.page_text')
                    }"
                    :server-items-length="m_total"
                    :loading="m_show_loading"
                    :loading-text="$t('global.loading_text')"
                    :no-data-text="$t('global.no_data_text')"
                    :no-results-text="$t('global.no_results_text')"
                    :must-sort="true"
                  >
                    <template v-slot:item.active_from="{ item }">
                      {{ item.active_from ? moment.utc(item.active_from).format(DATE_FORMAT) : null }}
                    </template>
                    <template v-slot:item.inactive_from="{ item }">
                      {{ item.inactive_from ? moment.utc(item.inactive_from).format(DATE_FORMAT) : null }}
                    </template>
                    <template v-slot:item.status="{ item }">
                      {{ $dd_integration_status(item.status) }}
                    </template>
                    <template v-slot:item.activated_by="{ item }">
                      {{ item.activated_by_name }}
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <action-button type="edit" @click="showForm(item.id, 'tenant-module', tennant.id)" :icon_only="true" small />
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-expansion-panels v-model="clpsLogExp" class="cstm-filter mt-4 elevation-0" v-if="tennant.id">
          <v-expansion-panel>
            <v-expansion-panel-header hide-actions>
              <span>
                <v-icon dark>{{ clpsLogIcon }}</v-icon>
                {{ $t("logs.title") }}
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-layout row wrap>
                <v-flex md12>
                  <v-data-table
                    :headers="headers_logs"
                    :items="logs"
                    :items-per-page="logs.length"
                    :options.sync="l_pagination"
                    :footer-props="{
                      showFirstLastPage: true,
                      'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
                      'items-per-page-all-text': $t('global.items_per_page_all_text'),
                      'items-per-page-text': $t('global.items_per_page_text'),
                      'page-text': $t('global.page_text')
                    }"
                    :server-items-length="l_total"
                    :loading="l_show_loading"
                    :loading-text="$t('global.loading_text')"
                    :no-data-text="$t('global.no_data_text')"
                    :no-results-text="$t('global.no_results_text')"
                    :must-sort="true"
                  >
                    <template v-slot:item.user_id="{ item }">
                      {{ item.user.person.first_name + " " + item.user.person.last_name }}
                    </template>

                    <template v-slot:item.action_id="{ item }">
                      <router-link :to="`/app${item.action_link}`" v-if="item.action_name && item.action_link">
                        {{ item.action_name }}
                      </router-link>
                      <div v-else>
                        {{ item.action_name || item.action_id }}
                      </div>
                    </template>

                    <template v-slot:item.created_at="{ item }">
                      {{ moment(item.created_at).format(MYSQL_DATETIME_FORMAT) }}
                    </template>

                    <template v-slot:item.actions="{ item }">
                      <action-button type="view" @click="viewLog(item.id)" :icon_only="true" small />
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-container>
    </v-form>

    <v-dialog v-model="showDialogForm" persistent max-width="960px">
      <div class="form-modal pa-4">
        <component
          :is="currentLoadedForm.form"
          :id="currentLoadedForm.id"
          :tenant_id="currentLoadedForm.tenant_id"
          :modal="true"
          @return_modal_form="return_modal_form"
          @return_modal_cancel_form="return_modal_cancel_form"
        ></component>
      </div>
    </v-dialog>

    <logDetail :key="reRenderShowLog" :show="showLog" :id="Number(selectedLog)" @callback_logdetailpopup_cancel="showLog = false" />
  </v-container>
</template>

<script>
import PhoneNumber from "awesome-phonenumber"
import logDetail from "@/modules/logs/partials/LogDetailPopup"
import VueTelInputVuetify from "@/mixins/vue-tel-input-vuetify/lib/vue-tel-input-vuetify.vue"

export default {
  name: "tennantForm",

  props: ["id"],

  components: {
    logDetail,
    "tenant-integration-form": () => import("@/modules/integrations/components/TenantForm"),
    "tenant-module-form": () => import("@/modules/modules/components/TenantForm"),
    "deletemodal-form": () => import("../components/DeleteModal"),
    VueTelInputVuetify
  },

  data() {
    return {
      is_setup: false,
      is_migrate: false,

      page_title: "",
      predata: {},
      tennant: {},
      organisations: [],
      persons: [],

      logs: [],
      l_total: 0,
      l_show_loading: false,
      l_refresh: false,
      l_pagination: {
        page: this.$getLocalStorage("__page_TenantLog_List", "page"),
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["id"]
      },

      integrations: [],
      i_total: 0,
      i_show_loading: false,
      i_refresh: false,
      i_pagination: {
        page: this.$getLocalStorage("__page_TenantIntegration_List", "page"),
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["id"]
      },

      modules: [],
      m_total: 0,
      m_show_loading: false,
      m_refresh: false,
      m_pagination: {
        page: this.$getLocalStorage("__page_TenantModule_List", "page"),
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["id"]
      },

      selectedLog: null,
      showLog: false,
      reRenderShowLog: 0,

      active_from_menu: false,
      inactive_from_menu: false,

      hidePassword: true,

      showDialogForm: false,
      currentFormId: "",
      currentForm: "",
      currentTenantId: "",

      coursetypegroups: [],
      coursetypes: [],
      ctg_ct_list: [],
      ctg_ct_list_columns: [],
      allowed_coursetypegroups: [],
      allowed_coursetypes: [],

      db_icon: "",
      db_icon_color: "",

      tennant_organisation: {},
      tennant_visiting_address: {},
      tennant_invoice_address: {},
      tmp_invoice_address: {},
      sameAsVisitingAddress: false,

      collapseExpand: undefined,
      collapseExpandIcon: "mdi-expand-all-outline",

      clpsInvDetIcon: "mdi-expand-all-outline",
      clpsInvDetExp: undefined,

      clpsVisAddIcon: "mdi-expand-all-outline",
      clpsVisAddExp: undefined,

      clpsInvAddIcon: "mdi-expand-all-outline",
      clpsInvAddExp: undefined,

      clpsDBIcon: "mdi-expand-all-outline",
      clpsDBExp: undefined,

      clpsSMSIcon: "mdi-expand-all-outline",
      clpsSMSExp: undefined,

      clpsCTGIcon: "mdi-expand-all-outline",
      clpsCTGExp: undefined,

      clpsIntIcon: "mdi-expand-all-outline",
      clpsIntExp: undefined,

      clpsModIcon: "mdi-expand-all-outline",
      clpsModExp: undefined,

      clpsLogIcon: "mdi-expand-all-outline",
      clpsLogExp: undefined,

      years: [],
      sms_report: [],

      dictionary: {
        attributes: {
          "tennant.organisation_id": this.$t("organisations.title"),
          "tennant.subdomain": this.$t("tennants.subdomain"),
          "tennant.dbname": this.$t("tennants.dbname"),
          "tennant.master_username": this.$t("tennants.master_username"),
          "tennant.master_password": this.$t("tennants.master_password"),
          "tennant.connection_name": this.$t("tennants.connection_name"),
          "tennant.email": this.$t("tennants.email"),
          "tennant.first_name": this.$t("tennants.first_name"),
          "tennant.last_name": this.$t("tennants.last_name"),
          "tennant.mobile": this.$t("tennants.mobile"),
          "tennant.status": this.$t("tennants.status"),
          "tennant.type": this.$t("tennants.type"),
          "tennant.active_from": this.$t("tennants.active_from"),
          "tennant.inactive_from": this.$t("tennants.inactive_from"),
          "tennant.payed_for_users": this.$t("tennants.payed_for_users"),
          "tennant.tenant_company": this.$t("tennants.tenant_company"),
          "tennant.sms_service": this.$t("tennants.sms_service"),
          "tennant.checklist_status": this.$t("tennants.checklist_status"),
          "tennant.course_id_increment_start": this.$t("tennants.course_id_increment_start"),
          "tennant.notif_email_from": this.$t("tennants.notif_email_from"),
          "organisation.tenant_company": this.$t("organisations.tenant_company"),
          "organisation.email": this.$t("organisations.email"),
          "organisation.vat": this.$t("organisations.vat"),
          "organisation.phone": this.$t("organisations.phone"),
          "organisation.owner": this.$t("organisations.owner"),
          "organisation.po_number": this.$t("organisations.po_number"),
          "organisation.invoice_ref": this.$t("organisations.invoice_ref"),
          "organisation.email_invoice": this.$t("organisations.email_invoice"),
          "visiting_address.street": this.$t("organisations.visiting_street"),
          "visiting_address.city": this.$t("organisations.visiting_city"),
          "visiting_address.state": this.$t("organisations.visiting_state"),
          "visiting_address.zip": this.$t("organisations.visiting_zip"),
          "visiting_address.country": this.$t("organisations.visiting_country"),
          "invoice_address.street": this.$t("organisations.invoice_street"),
          "invoice_address.city": this.$t("organisations.invoice_city"),
          "invoice_address.state": this.$t("organisations.invoice_state"),
          "invoice_address.zip": this.$t("organisations.invoice_zip"),
          "invoice_address.country": this.$t("organisations.invoice_country")
        }
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$validator.validateAll().then(() => {
      this.$leaveFormConfirmation(next, this.tennant, this.predata, this.save, this.isFormValid)
    })
  },

  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    },
    computedActiveFromDate: {
      get() {
        return this.tennant.active_from ? this.moment.utc(this.tennant.active_from).format(this.DATE_FORMAT) : ""
      },
      set(val) {
        this.$set(this.tennant, "active_from", this.$dateFormatChecker(val))
      }
    },
    computedInactiveFromDate: {
      get() {
        return this.tennant.inactive_from ? this.moment.utc(this.tennant.inactive_from).format(this.DATE_FORMAT) : ""
      },
      set(val) {
        this.$set(this.tennant, "inactive_from", this.$dateFormatChecker(val))
      }
    },
    isSetup() {
      if (_.has(this.tennant, "id")) {
        return this.tennant.is_setup != 1
      }

      return false
    },
    isMigrate() {
      if (_.has(this.tennant, "id")) {
        return this.tennant.is_setup == 1
      }

      return false
    },
    computedCurrentForm() {
      return this.currentForm
    },
    currentLoadedForm: function() {
      let form,
        id,
        tenant_id = null

      if (this.currentForm) {
        this.showDialogForm = true

        id = this.currentFormId
        form = this.currentForm
        tenant_id = this.currentTenantId
      }

      return {
        id: id,
        form: form,
        tenant_id: this.currentTenantId
      }
    },
    headers_integrations: {
      get() {
        return [
          { text: this.$t("integrations.name"), value: "name" },
          { text: this.$t("integrations.slug"), value: "slug" },
          { text: this.$t("integrations.status"), value: "status" },
          {
            text: this.$t("global.actions"),
            value: "actions",
            width: "10%",
            align: "end",
            sortable: false
          }
        ]
      }
    },
    headers_modules: {
      get() {
        return [
          { text: this.$t("modules.name"), value: "name" },
          { text: this.$t("modules.price"), value: "price" },
          { text: this.$t("modules.active_from"), value: "active_from" },
          { text: this.$t("modules.inactive_from"), value: "inactive_from" },
          { text: this.$t("modules.status"), value: "status" },
          { text: this.$t("modules.activated_by"), value: "activated_by" },
          {
            text: this.$t("global.actions"),
            value: "actions",
            width: "10%",
            align: "end",
            sortable: false
          }
        ]
      }
    },
    headers_logs: {
      get() {
        return [
          { text: this.$t("logs.id"), value: "id" },
          { text: this.$t("logs.user_id"), value: "user_id" },
          { text: this.$t("logs.action"), value: "action" },
          { text: this.$t("logs.ip_address"), value: "ip_address" },
          { text: this.$t("logs.created_at"), value: "created_at" },
          {
            text: this.$t("global.actions"),
            value: "actions",
            width: "10%",
            align: "end",
            sortable: false
          }
        ]
      }
    }
  },

  watch: {
    l_refresh: {
      handler() {
        if (this.l_refresh) {
          this.logs_list()
        }
      }
    },
    l_pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem("__page_TenantLog_List", newVal.page)
          }

          this.l_refresh = true
        }
      }
    },
    i_refresh: {
      handler() {
        if (this.i_refresh) {
          this.integrations_list()
        }
      }
    },
    i_pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem("__page_TenantIntegration_List", newVal.page)
          }

          this.i_refresh = true
        }
      }
    },
    m_refresh: {
      handler() {
        if (this.m_refresh) {
          this.modules_list()
        }
      }
    },
    m_pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem("__page_TenantModule_List", newVal.page)
          }

          this.m_refresh = true
        }
      }
    },
    sameAsVisitingAddress(val) {
      if (val) {
        this.tmp_invoice_address = this.tennant_invoice_address
        this.tennant_invoice_address = this.tennant_visiting_address
      } else {
        this.tennant_invoice_address = this.tmp_invoice_address
      }
    },
    toggleSelectAllCourseTypeGroup(val) {
      if (val) {
        this.allowed_coursetypegroups = this.coursetypegroups.map((a) => a.id)
      } else {
        this.allowed_coursetypegroups = [-1] // Hack to remove the list of course types in dropdown
      }

      this.courseTypeGroupChange()
    },
    toggleSelectAllCourseType(val) {
      if (val) {
        this.allowed_coursetypes = this.coursetypes.map((a) => a.id)
      } else {
        this.allowed_coursetypes = []
      }
    },
    clpsInvDetExp: {
      handler(newVal, oldVal) {
        this.clpsInvDetIcon = newVal === undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"
      }
    },
    clpsVisAddExp: {
      handler(newVal, oldVal) {
        this.clpsVisAddIcon = newVal === undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"
      }
    },
    clpsInvAddExp: {
      handler(newVal, oldVal) {
        this.clpsInvAddIcon = newVal === undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"
      }
    },
    clpsDBExp: {
      handler(newVal, oldVal) {
        this.clpsDBIcon = newVal === undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"
      }
    },
    clpsSMSExp: {
      handler(newVal, oldVal) {
        this.clpsSMSIcon = newVal === undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"
      }
    },
    clpsCTGExp: {
      handler(newVal, oldVal) {
        this.clpsCTGIcon = newVal === undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"
      }
    },
    clpsIntExp: {
      handler(newVal, oldVal) {
        this.clpsIntIcon = newVal === undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"
      }
    },
    clpsModExp: {
      handler(newVal, oldVal) {
        this.clpsModIcon = newVal === undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"
      }
    },
    clpsLogExp: {
      handler(newVal, oldVal) {
        this.clpsLogIcon = newVal === undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"
      }
    }
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {
    let lists = [
      {
        key: "coursetypegroups",
        module: "coursetypegroups",
        query: "show_all=true&sort_by=category&sort_order=asc"
      },
      {
        key: "organisations",
        module: "organisations",
        query: "show_all=true&resourcetype=organisation-basic"
      }
    ]

    axios.post(this.API_URL + "request/ddlists", lists).then((res) => {
      this.coursetypegroups = res.data.coursetypegroups
      this.organisations = res.data.organisations

      this.organisationChange()
      this.courseTypeAndGroupList()

      if (!this.id) {
        this.page_title = this.$t("tennants.new_tennant")

        this.tennant = {
          active_from: this.moment().format(this.MYSQL_DATE_FORMAT),
          status: this.$getDefaultDropdown(this.$dd_tennant_status()),
          sms_service: 0
        }

        // JSON stringify and parse to remove variable reactiveness
        this.loadPredata()
      } else {
        axios
          .get(this.API_URL + "tennant/" + this.id)
          .then((res) => {
            this.tennant = res.data.data
            this.tennant_organisation = this.tennant.tenant_organisation.organisation
            this.tennant_visiting_address = this.tennant.tenant_organisation.visiting_address
            this.tennant_invoice_address = this.tennant.tenant_organisation.invoice_address
            this.page_title = this.$t("tennants.edit_tennant")

            // JSON stringify and parse to remove variable reactiveness
            this.loadPredata()
            this.allowed_coursetypegroups = this.tennant.allowed_coursetypegroups.map((a) => a.id)
            this.allowed_coursetypes = this.tennant.allowed_coursetypes.map((a) => a.id)
            this.organisationChange()

            this.loadReport()
          })
          .catch((err) => console.log(err))
      }
    })
  },

  methods: {
    loadPredata() {
      this.predata = JSON.parse(JSON.stringify(this.tennant))
      this.predata.mobile_code = "47" // Norway country code
      this.predata.notif_sms_from_code = "47" // Norway country code

      if (this.predata.mobile) {
        let code = PhoneNumber(this.predata.mobile).getCountryCode()
        if (code) {
          let mobileJSON = PhoneNumber(this.predata.mobile).toJSON()
          this.predata.mobile = mobileJSON.number.significant || this.predata.mobile
          this.predata.mobile_code = code.toString()
        }
      }

      if (this.predata.notif_sms_from) {
        let code = PhoneNumber(this.predata.notif_sms_from).getCountryCode()
        if (code) {
          let mobileJSON = PhoneNumber(this.predata.notif_sms_from).toJSON()
          this.predata.notif_sms_from = mobileJSON.number.significant || this.predata.notif_sms_from
          this.predata.notif_sms_from_code = code.toString()
        }
      }
    },
    fn_toggleSelectAllCourseTypeGroup() {
      this.toggleSelectAllCourseTypeGroup = !this.toggleSelectAllCourseTypeGroup
    },
    fn_toggleSelectAllCourseType() {
      this.toggleSelectAllCourseType = !this.toggleSelectAllCourseType
    },
    courseTypeAndGroupList() {
      let vm = this
      let total_count = 0

      // Count total group and coursetype
      vm.coursetypegroups.forEach((ctg) => {
        let ct_ids = ctg.coursetypes.map((a) => a.id)
        total_count++ // Add to count the course type group
        total_count += ct_ids.length // Add course types count
      })

      // Get breakpoint
      let col_count =
        this.$vuetify.breakpoint.xl || this.$vuetify.breakpoint.lg
          ? 3
          : this.$vuetify.breakpoint.md || this.$vuetify.breakpoint.sm
          ? 2
          : this.$vuetify.breakpoint.xs
          ? 1
          : null

      // Set row count
      let row_count = Math.ceil(total_count / col_count)

      vm.coursetypegroups.forEach((ctg) => {
        let count = 1 + ctg.coursetypes.map((a) => a.id).length
        let len = vm.ctg_ct_list_columns.length

        // add new property in ctg variable
        ctg.key = "ctg-" + ctg.id
        ctg.type = "coursetypegroup"

        // add new property in ctg.coursetypes variable
        ctg.coursetypes.forEach((ct) => {
          ct.key = "ct-" + ct.id
          ct.type = "coursetype"
        })

        // If ctg_ct_list_columns length does not have any value
        if (len == 0) {
          // push new array
          vm.ctg_ct_list_columns.push(new Array())

          // insert course type group in the ctg_ct_list_columns array
          var new_index = vm.ctg_ct_list_columns.length - 1
          vm.ctg_ct_list_columns[new_index].push(ctg)
        } else {
          // variable to check if we need to create new array or note
          let create_new = true
          // variable to check if we need to insert the coursetype group in the existing array, save the index in this var
          let insert_index = null

          // loop thru ctg_ct_list_columns array to check if we need to create new or insert the course type group
          vm.ctg_ct_list_columns.forEach((group, index) => {
            let inner_count = 0

            // count all the items (course type and course type group) inside the array
            vm.ctg_ct_list_columns[index].forEach((item) => {
              inner_count += 1 + item.coursetypes.map((a) => a.id).length
            })

            // check if we can insert the ctg variable to an existing array
            if (inner_count + count <= row_count) {
              create_new = false
              insert_index = index
            }
          })

          if (create_new) {
            vm.ctg_ct_list_columns.push(new Array())

            var new_index = vm.ctg_ct_list_columns.length - 1
            vm.ctg_ct_list_columns[new_index].push(ctg)
          } else {
            vm.ctg_ct_list_columns[insert_index].push(ctg)
          }
        }
      })
    },
    courseTypeGroupChange(id) {
      let vm = this
      let ctg = vm.coursetypegroups.find((i) => i.id == id)

      if (ctg) {
        let ctg_ct_ids = ctg.coursetypes.map((a) => a.id)

        if (!vm.allowed_coursetypegroups.includes(ctg.id)) {
          // Clear all coursetype of the selected group
          vm.allowed_coursetypes = vm.allowed_coursetypes.filter(function(n) {
            return !ctg_ct_ids.includes(n)
          })
        } else {
          // Check all coursetype of the selected group
          ctg_ct_ids.forEach((ctid) => {
            if (!vm.allowed_coursetypes.includes(ctid)) {
              vm.allowed_coursetypes.push(ctid)
            }
          })
        }
      }
    },
    courseTypeChange() {
      let vm = this

      vm.coursetypegroups.forEach((ctg) => {
        let shouldCheck = false

        ctg.coursetypes.forEach((ct) => {
          if (vm.allowed_coursetypes.includes(ct.id)) {
            shouldCheck = true
          }
        })

        if (shouldCheck) {
          // Check if course type group id is already in the allowed_coursetypegroups array, if NOT, then it will be added
          if (!vm.allowed_coursetypegroups.includes(ctg.id)) {
            vm.allowed_coursetypegroups.push(ctg.id)
          }
        } else {
          // Delete the course type group id in allowed_coursetypegroups array, if there are no course types checked
          if (vm.allowed_coursetypegroups.indexOf(ctg.id) !== -1) {
            vm.allowed_coursetypegroups.splice(vm.allowed_coursetypegroups.indexOf(ctg.id), 1)
          }
        }
      })
    },
    setup(id) {
      let vm = this

      axios
        .put(this.API_URL + "tennant/setup/" + id)
        .then((res) => {
          vm.tennant = {}

          setTimeout(function() {
            vm.tennant = res.data.data
            vm.organisation = vm.tennant.organisation

            vm.$awn.success(vm.$t("global.tenant_setup_success"))
          }, 100)
        })
        .catch((err) => console.log(err))
    },
    migrate(id) {
      let vm = this

      axios.put(this.API_URL + "tennants/migration/" + id).then((res) => {
        if (res.data.status) {
          vm.$awn.success(vm.$t("tennants.db_migration_success"))
        } else {
          vm.$awn.alert(res.data.message)
        }
      })
    },
    organisationChange() {
      if (this.tennant.organisation_id) {
        // Get Persons
        axios.get(this.API_URL + "persons?show_all=true&type=person&query_organisation_id=" + this.tennant.organisation_id).then((res) => {
          this.persons = res.data.data
        })

        // Set tenant company
        let org = this.organisations.find((i) => i.id == this.tennant.organisation_id)
        if (org) {
          if (!this.tennant.id) {
            this.tennant.tenant_company = org.name
            this.loadPredata()
          } else {
            if (!this.tennant.tenant_company) {
              this.tennant.tenant_company = org.name
              this.loadPredata()
            }
          }

          this.tennant_organisation = {
            tenant_company: org.name,
            email: org.email,
            vat: org.vat,
            phone: org.phone
          }
          this.tennant_visiting_address = {
            street: org.addresses.visiting.street,
            city: org.addresses.visiting.city,
            state: org.addresses.visiting.state,
            zip: org.addresses.visiting.zip,
            country: org.addresses.visiting.country
          }
          this.tennant_invoice_address = {
            street: org.addresses.invoice.street,
            city: org.addresses.invoice.city,
            state: org.addresses.invoice.state,
            zip: org.addresses.invoice.zip,
            country: org.addresses.invoice.country
          }
        }
      }
    },
    personChange(id) {
      if (id) {
        axios
          .get(this.API_URL + "person/" + id)
          .then((res) => {
            let person = res.data.data

            this.$set(this.tennant, "first_name", person.first_name)
            this.$set(this.tennant, "last_name", person.last_name)
            this.$set(this.tennant, "email", person.user.email)
            this.$set(this.tennant, "mobile", person.mobile)
          })
          .catch((err) => console.log(err))
      }
    },
    save() {
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            let vm = this

            this.tennant_organisation.tenant_company = this.tennant.tenant_company

            if (!this.tennant.id) {
              // Create
              axios
                .post(this.API_URL + "tennant", {
                  organisation_id: this.tennant.organisation_id,
                  subdomain: this.tennant.subdomain,
                  dbname: this.tennant.dbname,
                  master_username: this.tennant.master_username,
                  master_password: this.tennant.master_password,
                  connection_name: this.tennant.connection_name,
                  email: this.tennant.email,
                  first_name: this.tennant.first_name,
                  last_name: this.tennant.last_name,
                  mobile: this.$formatPhoneNumber(this.tennant.mobile, this.tennant.mobile_code),
                  status: this.tennant.status,
                  type: this.tennant.type,
                  active_from: this.tennant.active_from,
                  inactive_from: this.tennant.inactive_from,
                  payed_for_users: this.tennant.payed_for_users,
                  tenant_company: this.tennant.tenant_company,
                  tenant_vat_number: this.tennant.tenant_vat_number,
                  person_id: this.tennant.person_id,
                  sms_service: this.tennant.sms_service,
                  checklist_status: this.tennant.checklist_status,
                  course_id_increment_start: this.tennant.course_id_increment_start,
                  tenant_organisation: this.tennant_organisation,
                  tenant_visiting_address: this.tennant_visiting_address,
                  tenant_invoice_address: this.tennant_invoice_address,
                  swagger_token: this.tennant.swagger_token,
                  allowed_coursetypegroups: this.allowed_coursetypegroups.join(","),
                  allowed_coursetypes: this.allowed_coursetypes.join(","),
                  notif_email_from: this.tennant.notif_email_from,
                  notif_sms_from: this.$formatPhoneNumber(this.tennant.notif_sms_from, this.tennant.notif_sms_from_code)
                })
                .then((res) => {
                  if (typeof res.data.errors !== "undefined") {
                  } else {
                    if (res.data.data.id) {
                      vm.tennant = res.data.data
                      vm.loadPredata()

                      vm.page_title = this.$t("tennants.edit_tennant")

                      vm.$awn.success(vm.$t("global.create_success"))
                      vm.$router.replace(this.BACKEND_URL + `/tennants/edit/${vm.tennant.id}`).catch(() => {})

                      vm.$awn.confirm(
                        vm.$t("tennants.activate_now_later"),
                        () => {
                          vm.setup(vm.tennant.id)
                        },
                        () => {},
                        {
                          labels: {
                            confirmOk: vm.$t("tennants.btn_now"),
                            confirmCancel: vm.$t("tennants.btn_later")
                          }
                        }
                      )
                    }
                  }
                })
                .catch((err) => console.log(err))
            } else {
              // Update
              axios
                .put(this.API_URL + "tennant", {
                  id: this.tennant.id,
                  organisation_id: this.tennant.organisation_id,
                  subdomain: this.tennant.subdomain,
                  dbname: this.tennant.dbname,
                  master_username: this.tennant.master_username,
                  master_password: this.tennant.master_password,
                  connection_name: this.tennant.connection_name,
                  email: this.tennant.email,
                  first_name: this.tennant.first_name,
                  last_name: this.tennant.last_name,
                  mobile: this.$formatPhoneNumber(this.tennant.mobile, this.tennant.mobile_code),
                  status: this.tennant.status,
                  type: this.tennant.type,
                  active_from: this.tennant.active_from,
                  inactive_from: this.tennant.inactive_from,
                  payed_for_users: this.tennant.payed_for_users,
                  tenant_company: this.tennant.tenant_company,
                  tenant_vat_number: this.tennant.tenant_vat_number,
                  person_id: this.tennant.person_id,
                  sms_service: this.tennant.sms_service,
                  checklist_status: this.tennant.checklist_status,
                  course_id_increment_start: this.tennant.course_id_increment_start,
                  tenant_organisation: this.tennant_organisation,
                  tenant_visiting_address: this.tennant_visiting_address,
                  tenant_invoice_address: this.tennant_invoice_address,
                  swagger_token: this.tennant.swagger_token,
                  allowed_coursetypegroups: this.allowed_coursetypegroups.join(","),
                  allowed_coursetypes: this.allowed_coursetypes.join(","),
                  notif_email_from: this.tennant.notif_email_from,
                  notif_sms_from: this.$formatPhoneNumber(this.tennant.notif_sms_from, this.tennant.notif_sms_from_code)
                })
                .then((res) => {
                  vm.tennant = res.data.data
                  vm.loadPredata()

                  vm.page_title = this.$t("tennants.edit_tennant")
                  vm.integrations_list()
                  vm.modules_list()

                  vm.$awn.success(vm.$t("global.update_success"))
                  vm.$router.replace(this.BACKEND_URL + `/tennants/edit/${vm.tennant.id}`).catch(() => {})
                })
                .catch((err) => console.log(err))
            }
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },
    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          vm.showForm(id, "deletemodal")
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },
    showForm(id, type, tenant_id = null) {
      this.currentFormId = id
      this.currentTenantId = tenant_id
      this.currentForm = type + "-form"
    },
    return_modal_form(data) {
      this.return_modal_cancel_form()

      if (data == "delete-modal") {
        this.$router.push(this.BACKEND_URL + "/tennants")
      }

      if (data == "tenant-integration") {
        this.i_refresh = true
      }

      if (data == "tenant-module") {
        this.m_refresh = true
      }
    },
    return_modal_cancel_form() {
      this.currentFormId = ""
      this.currentTenantId = ""
      this.currentForm = ""
      this.showDialogForm = false
    },
    checkDatabaseExist() {
      if (!this.tennant.id) {
        axios
          .post(this.API_URL + "tennant/checkdb", {
            dbname: this.tennant.dbname,
            type: this.tennant.type
          })
          .then((res) => {
            this.db_icon = res.data.exist ? "clear" : "done"
            this.db_icon_color = res.data.exist ? "error" : "success"

            if (res.data.exist) {
              this.tennant.dbname = res.data.db_name
            }
          })
          .catch((err) => console.log(err))
      }
    },
    subdomainChange() {
      if (!this.tennant.id) {
        let subdomain = JSON.parse(JSON.stringify(this.tennant.subdomain))

        this.$set(this.tennant, "master_username", subdomain)
        this.$set(this.tennant, "master_password", this.$generatePassword())
        this.$set(this.tennant, "dbname", subdomain)

        this.checkDatabaseExist()
      }
    },

    phoneNoSpace() {
      if (this.tennant.mobile) {
        this.tennant.mobile = this.tennant.mobile.replace(/\s/g, "")
        let field = this.errors.items.find((i) => i.field == "tennant.mobile" && i.rule == "no_space")
        if (field) this.$validator.errors.removeById(field.id)
      }
    },
    integrations_list() {
      this.i_show_loading = true

      let { sortBy, descending, page, itemsPerPage } = this.i_pagination
      let query = this.$queryString(this.i_pagination, {
        tenant_id: this.tennant.id
      })

      if (this.tennant.id) {
        axios
          .get(this.API_URL + "tenant-integrations" + "?" + query)
          .then((res) => {
            this.integrations = res.data.data
            this.i_total = res.data.meta.total
            this.i_refresh = false
            this.i_show_loading = false

            this.i_pagination.page = res.data.meta.current_page
            this.i_pagination.itemsPerPage = Number(res.data.meta.per_page)
          })
          .catch((err) => console.log(err))
      }
    },
    modules_list() {
      this.m_show_loading = true

      let { sortBy, descending, page, itemsPerPage } = this.m_pagination
      let query = this.$queryString(this.m_pagination, {
        tenant_id: this.tennant.id
      })

      if (this.tennant.id) {
        axios
          .get(this.API_URL + "tenant-modules" + "?" + query)
          .then((res) => {
            this.modules = res.data.data
            this.m_total = res.data.meta.total
            this.m_refresh = false
            this.m_show_loading = false

            this.m_pagination.page = res.data.meta.current_page
            this.m_pagination.itemsPerPage = Number(res.data.meta.per_page)
          })
          .catch((err) => console.log(err))
      }
    },
    logs_list() {
      this.l_show_loading = true

      let { sortBy, descending, page, itemsPerPage } = this.l_pagination
      let query = this.$queryString(this.l_pagination, {
        action_model: "tennant",
        action_id: this.tennant.id
      })

      if (this.tennant.id) {
        axios
          .get(this.API_URL + "logs" + "?" + query)
          .then((res) => {
            this.logs = res.data.data
            this.l_total = res.data.meta.total
            this.l_refresh = false
            this.l_show_loading = false

            this.l_pagination.page = res.data.meta.current_page
            this.l_pagination.itemsPerPage = Number(res.data.meta.per_page)
          })
          .catch((err) => console.log(err))
      }
    },
    viewLog(id) {
      this.selectedLog = id
      this.reRenderShowLog++
      this.showLog = true
    },
    visitingZipCodeChange() {
      this.$getCity(this.tennant_visiting_address.zip, this.tennant_visiting_address.country)
        .then((res) => {
          if (res.status == 200) {
            this.$set(this.tennant_visiting_address, "city", res.data.postalCode.city)
          }
        })
        .catch((error) => {
          this.$set(this.tennant_visiting_address, "city", null)
        })
    },
    invoiceZipCodeChange() {
      this.$getCity(this.tennant_invoice_address.zip, this.tennant_invoice_address.country)
        .then((res) => {
          if (res.status == 200) {
            this.$set(this.tennant_invoice_address, "city", res.data.postalCode.city)
          }
        })
        .catch((error) => {
          this.$set(this.tennant_invoice_address, "city", null)
        })
    },
    loadReport() {
      this.selectedYear = this.selectedYear || parseInt(this.moment().format("YYYY"))

      axios
        .get(this.API_URL + "report/sms-usage-tenant?tenant=" + this.tennant.id)
        .then((res) => {
          this.sms_report = res.data.data

          for (const [key, item] of Object.entries(res.data.years)) {
            this.years.push(item)
          }
        })
        .catch((err) => console.log(err))
    },
    toggleCollapse() {
      this.collapseExpand = this.collapseExpand === 0 ? undefined : 0
      this.collapseExpandIcon =
        this.collapseExpand === 1 || this.collapseExpand == undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"

      this.clpsInvDetExp = this.collapseExpand
      this.clpsVisAddExp = this.collapseExpand
      this.clpsInvAddExp = this.collapseExpand
      this.clpsDBExp = this.collapseExpand
      this.clpsSMSExp = this.collapseExpand
      this.clpsCTGExp = this.collapseExpand
      this.clpsIntExp = this.collapseExpand
      this.clpsModExp = this.collapseExpand
      this.clpsLogExp = this.collapseExpand
    },
    resendVerifyNotifEmail() {
      let vm = this

      axios
        .post(this.API_URL + "smpt2go/single_sender_emails/verify", {
          tenant_id: this.tennant.id
        })
        .then((res) => {
          let data = res.data
          let code = res.code

          vm.tennant.notif_email_verified = data.verified ? 1 : 0
          vm.loadPredata()
        })
        .catch((err) => {
          let message = err.response.data.api_response.data.data.error || null
          if (message) {
            vm.$awn.alert(message)
          }
        })
    },
    generateNewSwaggerToken() {
      let token = this.$generateToken(24)
      this.$set(this.tennant, "swagger_token", token)
    }
  }
}
</script>

<style>
.not-verified .v-messages__message {
  color: red !important;
}
</style>
